import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import React from "react";

const DocumentExpiredModal = ({
  isOpen,
  onClose,
  setExpiredDocDate,
  expiredDocDateError,
  expiredDocDate,
  isDocUpdating,
  handleAction,
}) => {
  return (
    <>
      <Dialog open={isOpen} onClose={onClose} className="relative z-50">
        <DialogBackdrop className="fixed inset-0 bg-gray-500/75" />
        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <DialogPanel className="w-full max-w-md transform overflow-hidden rounded-xl bg-white shadow-xl transition-all">
              <div className="bg-[#21140E0F] relative px-6 py-4">
                {/* Header */}
                <div className="border-b">
                  <div className="flex justify-between items-center">
                    <h3 className="text-xl font-semibold text-[#1e3a8a]">
                      Set Document Expiry Date
                    </h3>
                    <button
                      onClick={onClose}
                      className="text-gray-400 hover:text-gray-600 text-2xl"
                    >
                      &times;
                    </button>
                  </div>
                </div>

                {/* Radio Options */}
                <div className="py-4 space-y-3">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Document Expiry Date <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="date"
                    className={`w-full px-3 py-2 border ${
                      expiredDocDateError ? "border-red-300" : "border-gray-300"
                    } rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    onChange={(e) => {
                      setExpiredDocDate(e.target.value);
                    }}
                    value={expiredDocDate}
                  />
                  {expiredDocDateError && (
                    <p className="text-red-700">{expiredDocDateError}</p>
                  )}
                </div>

                {/* Action Buttons */}
                <div className="py-4 gap-3 flex justify-between border-t">
                  <button
                    className=" w-full px-4 py-2 bg-[#1e3a8a] text-white rounded-lg hover:bg-blue-900 transition"
                    onClick={() => handleAction()}
                    disabled={isDocUpdating}
                  >
                    {isDocUpdating ? "loading..." : "Set"}
                  </button>
                </div>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default DocumentExpiredModal;
